import axios from "axios";

const API = "";

// Axios client for Admin DB push subscriptions.
// Sends `ihtp_admin_session` cookie automatically via withCredentials.
const adminPushApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default adminPushApi;
